import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter']),
  },
  methods: {
    ...mapMutations(['setProgress']),
    ...mapActions(['getInfos']),
    ...mapActions(['getSessions']),
    formatDay(day) {
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name]);
    },
  }
})

export default mixins
